import { render, staticRenderFns } from "./SupportingCommunityMentalHealth.vue?vue&type=template&id=13e6c8f0&"
import script from "./SupportingCommunityMentalHealth.vue?vue&type=script&lang=js&"
export * from "./SupportingCommunityMentalHealth.vue?vue&type=script&lang=js&"
import style0 from "./SupportingCommunityMentalHealth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports